export default __webpack_public_path__ + "static/media/TheGuarantors_Logo.b133f95f.svg";